import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginRest } from '../../../login/login.rest';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { UsersListRest } from './users-list.rest'
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { MessageBoxComponent } from '../../../core/shared/message-box.component';
import { Subscription } from 'rxjs';
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';
import { GridParamsRestorable } from '../../../core/services/grid-params-restoring/grid-params-restoring.model';
import { SortedColumn, GridMainFilter } from '../../../core/shared/grid/grid.model';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit, HasPermissions, AfterViewInit, GridParamsRestorable {
  readonly detailsPath: string = "/users/user";

  private messageBoxSubscription: Subscription;
  permissions: Permissions;

  private showNotActive: boolean = false;
  public hideToggles: boolean;
  public expanded: boolean;
  public mainFilter: GridMainFilter[];

  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;
  private path: string;
  private currentUser: any;
  public viewEnable = true;
  public initialFilters: any;
  public initialPageNumber: number = 0;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn;
  public editedItemId: string;
  public previousMainFilters: any = {};

  private headers = [

    { displayName: 'Imię i nazwisko', propertyName: 'fullName', propertyType: 'string' },
    { displayName: 'Login', propertyName: 'login', propertyType: 'string' },
    { displayName: 'Pracownik', propertyName: 'employee', propertyType: 'string' },
    { displayName: 'Rola', propertyName: 'role', propertyType: 'string' },
    { displayName: 'Przełożony', propertyName: 'superior', propertyType: 'string' },
    { displayName: 'Seria', propertyName: 'numeratorSerie', propertyType: 'string' },
    { displayName: 'Aktywny', propertyName: 'isActive', propertyType: 'bool' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private loginRest: LoginRest,
    private permissionService: PermissionsService,
    private rest: UsersListRest,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService
  ) {
    this.onResize();
  }

  public onMessageBoxClose() {
    if (this.messageBoxSubscription) {
      this.messageBoxSubscription.unsubscribe();
    }
  }

  public setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);

    if (!this.permissions.canShow) {
      sweetAlert("Brak uprawnień.")
    }
  }

  ngOnInit() {
    this.spinnerService.show();
    this.mainFilter = new Array();
    this.tryRestoreFiltersAndPage();
    this.path = 'api/users/grid';
    this.setPermissions("User");
  }

  ngAfterViewInit() {
    this.grid.mainFilter = this.mainFilter;
    this.spinnerService.hide();
  }

  private getActionButtons() {
    return [];
  }

  public addUser() {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
    this.router.navigate(['../users/user', 'new'], {relativeTo: this.route });
  }

  private onRowEdit(row: any) {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id);
    this.router.navigate(['../users/user', row.name], {queryParams: {userName: row.name}, relativeTo: this.route });
  }

  private onRowDelete(row: any) {
    let buttons = {
      yes: { text: "Tak", value: "yes" },
      no: { text: "Nie", value: "no" }
    }

    let message = `Czy na pewno usunąć użytkownika ${row.firstName} ${row.lastName}`;
    sweetAlert(message, {
      buttons: buttons
    }).then((value) => {
      switch (value) {
        case "yes":
            const action = this.rest.deleteUser;
            action.call(this.rest, row.id).subscribe((result: string) => {
              if (result) {
                sweetAlert({ text: `Usunięto użytkownika` });
                this.grid.refreshData(false);
              }
          });
          break;
      }
    });
  }

  private tryRestoreFiltersAndPage() {
    var previousGridParams = this.gridParamsRestoringService.getPreviousGridParams(this.detailsPath);
    if (!previousGridParams) {
      return;
    }

    this.initialFilters = previousGridParams.initialFilters;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    // this.previousMainFilters = previousGridParams.previousMainFilters;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
  }

  private setFilter(internalName: string, filterValue: any) {
    if (this.mainFilter != null) {
      this.mainFilter.forEach((item, index) => {
        if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
      });

      if (filterValue !== undefined) {
        this.mainFilter.push({ internalName: internalName, value: filterValue });
      }

      this.grid.mainFilter = this.mainFilter;
    }
  }


  public filter() {
    this.setFilter('ShowNotActive', !this.showNotActive);

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  public clearFilter() {
    this.mainFilter.forEach((item, index) => {
      if (item.internalName === 'ShowNotActive') { this.mainFilter.splice(index, 1); }
    });

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 769) {
      this.hideToggles = true;
      this.expanded = false;
    } else {
      this.hideToggles = false;
      this.expanded = true;
    }
  }

  private setFiltersFromRestoredData() {
    const showNotActive = this.findFilter('ShowNotActive');
    if (showNotActive != null && showNotActive === 'true') {
      this.showNotActive = false;
    } else if (showNotActive != null && showNotActive === 'false') {
      this.showNotActive = true;
    } else {
      this.showNotActive = this.showNotActive;
    }
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }  
}
